import React from "react";
import { IValidation } from "./form";
import { CUIT_PLACEHOLDER, IVA_SITUATIONS } from "../utils/constants";

export interface ICountryFieldConfig {
  id: string;
  label: string;
  type: string;
  required: boolean;
  validation?: IValidation[];
  order?: number;
  placeholder?: string;
  options?: Array<{ value: string; label: string }>;
}

export interface ICountryStrategy {
  code: string;
  name: string;
  fields: ICountryFieldConfig[];
  getValidations: () => IValidation[];
  transformSubmitData?: (
    data: Record<string, unknown>
  ) => Record<string, unknown>;
  customComponents?: Record<string, React.ComponentType<unknown>>;
}

export interface ICountryStrategyFactory {
  getStrategy: (countryCode: string) => ICountryStrategy;
  getAllStrategies: () => ICountryStrategy[];
  registerStrategy: (strategy: ICountryStrategy) => void;
}

export const FIELD_USER_NAME: ICountryFieldConfig = {
  id: "userName",
  label: "Nombre y Apellido",
  type: "text",
  required: true,
  order: 1,
  placeholder: "Ingresar nombre y apellido",
};

export const FIELD_ALIAS: ICountryFieldConfig = {
  id: "name",
  label: "Alias",
  type: "text",
  required: true,
  order: 2,
  placeholder: "Ingresar alias",
};

export const FIELD_BUSINESS_NAME: ICountryFieldConfig = {
  id: "businessName",
  label: "Razón Social",
  type: "text",
  required: true,
  order: 3,
  placeholder: "Razón Social",
};

export const FIELD_COMMERCIAL_ADDRESS: ICountryFieldConfig = {
  id: "commercialAddress",
  label: "Dirección Comercial",
  type: "text",
  required: true,
  placeholder: "Dirección Comercial",
};

export const FIELD_CUIT: ICountryFieldConfig = {
  id: "cuit",
  label: "CUIT",
  type: "text",
  required: true,
  placeholder: CUIT_PLACEHOLDER,
};

export const FIELD_NIT: ICountryFieldConfig = {
  id: "cuit",
  label: "NIT",
  type: "text",
  required: true,
  placeholder: "Ingresar número de NIT sin guiones ni puntos.",
};

export const FIELD_RUC: ICountryFieldConfig = {
  id: "cuit",
  label: "RUC",
  type: "text",
  required: true,
  placeholder: "Ingresar número de RUC sin guiones ni puntos.",
};

export const FIELD_IVA_SITUATION = {
  id: "ivaSituation",
  label: "Condición ante el IVA",
  type: "select",
  required: true,
  options: IVA_SITUATIONS.map((situation) => ({
    value: situation,
    label: situation,
  })),
};
